// Import Statements
import Watch from "./Component/Watch";
import TemperatureForecast from "./Component/Condition";
import About from "./Component/AboutPage";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// App Component
export default function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route exact path="/" element={<Watch />}></Route>
          <Route
            exact
            path="/Maximum_Temperature"
            element={<TemperatureForecast />}
          ></Route>
          <Route exact path="/About" element={<About />}></Route>
        </Routes>
      </div>
    </Router>
  );
}
